import { toast } from "react-toastify";

export function successToast(message: string) {
  toast.dismiss();
  if (message?.length) {
    toast.success(message);
  } else {
    toast.error("Something went wrong");
  }
}
export function errorToast(message: string) {
  toast.dismiss();
  if (message?.length) {
    toast.error(message);
  } else {
    toast.error("Something went wrong");
  }
}
export function warnToast(message: string) {
  toast.dismiss();
  if (message?.length) {
    toast.warn(message);
  } else {
    toast.error("Something went wrong");
  }
}
